import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-256acd7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-Pretendar mt-4" }
const _hoisted_2 = ["height", "src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "steps-container" }
const _hoisted_5 = { class: "d-none d-lg-block" }
const _hoisted_6 = { class: "row g-4 font-Pretendar cola-color" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-5"
}
const _hoisted_8 = { class: "card-body p-4 d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-sm-3 mb-1" }
const _hoisted_10 = { class: "step-number" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "instruction-image mt-auto" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "col-lg-7" }
const _hoisted_16 = ["onMouseenter"]
const _hoisted_17 = { class: "card-body p-4" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "d-flex align-items-center mb-sm-3 mb-1" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = {
  key: 0,
  class: "row mt-4 font-Pretendar cola-color"
}
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "card-body p-4" }
const _hoisted_26 = { class: "row align-items-center" }
const _hoisted_27 = { class: "col-md-8" }
const _hoisted_28 = { class: "d-flex align-items-center mb-sm-3 mb-1" }
const _hoisted_29 = { class: "step-number" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "instruction-image" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "d-sm-none font-Pretendar cola-color" }
const _hoisted_36 = { class: "swiper-wrapper" }
const _hoisted_37 = ["onMouseenter"]
const _hoisted_38 = { class: "card-body p-4 d-flex flex-column" }
const _hoisted_39 = { class: "d-flex align-items-center mb-sm-3 mb-1" }
const _hoisted_40 = { class: "step-number" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["src", "alt"]

import HeadingBox from '../components/heading-box.vue';
import { onMounted, ref } from 'vue';
import SwiperComponent from 'swiper';

interface Step {
  number: number;
  title: string;
  subtitle: string;
  image: string;
  alt: string;
}

interface Props {
  headingTitle?: string;
  headingType?: 'challenge' | 'rewards' | 'qna';
  mainImage?: string;
  mainImageHeight?: number;
  mainTitle?: string;
  steps?: Step[];
  hoverColor?: string;
  primaryColor?: string;
  backgroundColor?: string;
  textColor?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    headingTitle: { default: '' },
    headingType: { default: 'challenge' },
    mainImage: { default: require('../images/how-to-step-title1.png') },
    mainImageHeight: { default: 66 },
    mainTitle: { default: '페트병을 모았다면, 이제 수거 신청만 하면 끝. <br>누구나 쉽게 참여할 수 있는 제로 웨이스트 실천의 <br>마지막 단계입니다' },
    steps: { default: () => [
    {
      number: 1,
      title: '동봉된 비닐을 박스에 넣고 \n페트병 채우기',
      subtitle: '비닐도 모두 재활용됩니다.',
      image: require('../images/step-img-1.png'),
      alt: '비닐과 페트병'
    },
    {
      number: 2,
      title: '테이프로\n밀봉하기',
      subtitle: '가볍게\n밀봉해 주세요.',
      image: require('../images/step-img-2.png'),
      alt: '박스 테이핑'
    },
    {
      number: 3,
      title: '수거 신청하기',
      subtitle: '박스 상단 QR코드 스캔\nor 캠페인 페이지 접속',
      image: require('../images/step-img-3.png'),
      alt: 'QR코드 스캔'
    },
    {
      number: 4,
      title: '등록한 주소지\n문 앞에 박스 놓아두기',
      subtitle: '수거 신청 후 3~4일 이내\n수거예정',
      image: require('../images/step-img-4.png'),
      alt: '박스 배치'
    }
  ] },
    hoverColor: { default: '#f40000' },
    primaryColor: { default: '#f40000' },
    backgroundColor: { default: '#fff' },
    textColor: { default: '#000' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "1f73b494": (__props.primaryColor),
  "336c565a": (__props.hoverColor),
  "414547e2": (__props.backgroundColor),
  "8cece5fa": (__props.textColor)
}))



const hoveredCard = ref<number | null>(null);

const swiperRef = ref<HTMLDivElement>();
onMounted(() => {
  new SwiperComponent(swiperRef.value!, {
    slidesPerView: 2.8,
    spaceBetween: 15,
    modules: [],
    breakpoints: {
      381: {
        slidesPerView: 3.3,
      },
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HeadingBox, {
      title: __props.headingTitle,
      type: __props.headingType,
      "title-class": 'font-Pretendar fw-bold'
    }, null, 8, ["title", "type"]),
    _createElementVNode("div", _hoisted_1, [
      (__props.mainImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            height: __props.mainImageHeight,
            src: __props.mainImage,
            alt: "Main title image",
            class: "titleImg"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("h3", {
        class: "cola-color mt-4 d-none d-sm-block text-38",
        innerHTML: __props.mainTitle
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (__props.steps[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card h-100 shadow-sm instruction-card", { 'red-hover': hoveredCard.value === __props.steps[0].number }]),
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hoveredCard.value = __props.steps[0].number)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoveredCard.value = null))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.steps[0].number), 1)
                    ]),
                    _createElementVNode("h3", {
                      class: "fw-bold mb-3 white-space-preline text-35",
                      innerHTML: __props.steps[0].title
                    }, null, 8, _hoisted_11),
                    _createElementVNode("p", {
                      class: "mb-4 sub",
                      innerHTML: __props.steps[0].subtitle
                    }, null, 8, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: __props.steps[0].image,
                        alt: __props.steps[0].alt,
                        class: "img-fluid rounded"
                      }, null, 8, _hoisted_14)
                    ])
                  ])
                ], 34)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps.slice(1, 3), (step) => {
              return (_openBlock(), _createElementBlock("div", {
                key: step.number,
                class: _normalizeClass(["card shadow-sm instruction-card", [
                  { 'red-hover': hoveredCard.value === step.number },
                  { 'mb-4': step.number === 2 }
                ]]),
                onMouseenter: ($event: any) => (hoveredCard.value = step.number),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hoveredCard.value = null))
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'order-2 text-align-right': step.number === 3 })
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["step-number", { 'ms-auto': step.number === 3 }])
                        }, _toDisplayString(step.number), 3)
                      ]),
                      _createElementVNode("h4", {
                        class: "fw-bold mb-3 white-space-preline",
                        innerHTML: step.title
                      }, null, 8, _hoisted_20),
                      _createElementVNode("p", {
                        class: "mb-3 sub white-space-preline",
                        innerHTML: step.subtitle
                      }, null, 8, _hoisted_21)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["instruction-image", { 'order-1': step.number === 3 }])
                    }, [
                      _createElementVNode("img", {
                        src: step.image,
                        alt: step.alt,
                        class: "img-fluid rounded"
                      }, null, 8, _hoisted_22)
                    ], 2)
                  ])
                ])
              ], 42, _hoisted_16))
            }), 128))
          ])
        ]),
        (__props.steps[3])
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card shadow-sm instruction-card", { 'red-hover': hoveredCard.value === __props.steps[3].number }]),
                  onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (hoveredCard.value = __props.steps[3].number)),
                  onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (hoveredCard.value = null))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(__props.steps[3].number), 1)
                        ]),
                        _createElementVNode("h4", {
                          class: "fw-bold mb-3 white-space-preline",
                          innerHTML: __props.steps[3].title
                        }, null, 8, _hoisted_30),
                        _createElementVNode("p", {
                          class: "sub",
                          innerHTML: __props.steps[3].subtitle
                        }, null, 8, _hoisted_31)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("img", {
                            src: __props.steps[3].image,
                            alt: __props.steps[3].alt,
                            class: "img-fluid rounded"
                          }, null, 8, _hoisted_34)
                        ])
                      ])
                    ])
                  ])
                ], 34)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          ref_key: "swiperRef",
          ref: swiperRef,
          class: "swiper"
        }, [
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "swiper-slide"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card h-100 shadow-sm instruction-card", { 'red-hover': hoveredCard.value === step.number }]),
                  onMouseenter: ($event: any) => (hoveredCard.value = step.number),
                  onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (hoveredCard.value = null))
                }, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(step.number), 1)
                    ]),
                    _createElementVNode("h3", {
                      class: "fw-bold mb-sm-3 mb-1 white-space-preline title text-8-3",
                      innerHTML: step.title
                    }, null, 8, _hoisted_41),
                    _createElementVNode("div", {
                      class: "mb-sm-4 sub text-8-3",
                      innerHTML: step.subtitle
                    }, null, 8, _hoisted_42),
                    _createElementVNode("img", {
                      src: step.image,
                      alt: step.alt,
                      class: "instruction-image mt-auto"
                    }, null, 8, _hoisted_43)
                  ])
                ], 42, _hoisted_37)
              ]))
            }), 128))
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})